import React from 'react';

// Deliberately small, safe Markdown subset. Raw HTML and executable links are never rendered.
export default function Markdown({ text = '' }) {
  const inline = (line) => line.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith('**') ? <strong key={i}>{part.slice(2, -2)}</strong> : part);
  const lines = text.split(/\r?\n/);
  const content = [];
  const cells = line => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(cell => cell.trim());
  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    if (line.includes('|') && lines[i + 1]?.includes('|') &&
      cells(lines[i + 1]).every(cell => /^:?-{3,}:?$/.test(cell))) {
      const headings = cells(line);
      const rows = [];
      i += 2;
      while (i < lines.length && lines[i].includes('|') && lines[i].trim()) {
        rows.push(cells(lines[i])); i += 1;
      }
      i -= 1;
      content.push(<div className="table-responsive" key={i}><table className="table table-bordered table-sm">
        <thead><tr>{headings.map((cell, j) => <th scope="col" key={j}>{inline(cell)}</th>)}</tr></thead>
        <tbody>{rows.map((row, j) => <tr key={j}>{headings.map((_, k) => <td key={k}>{inline(row[k] || '')}</td>)}</tr>)}</tbody>
      </table></div>);
      continue;
    }
    content.push((() => {
    if (line.startsWith('### ')) return <h6 key={i}>{inline(line.slice(4))}</h6>;
    if (line.startsWith('## ')) return <h5 key={i}>{inline(line.slice(3))}</h5>;
    if (line.startsWith('# ')) return <h4 key={i}>{inline(line.slice(2))}</h4>;
    if (line.startsWith('- ')) return <p key={i}>• {inline(line.slice(2))}</p>;
    return line ? <p key={i}>{inline(line)}</p> : null;
    })());
  }
  return <div className="portal-help-markdown">{content}</div>;
}
